export const VALUE_PLANSTARTER_PLAN = 'value_planstarter_plan';
export const BYPASS_GWG_PLAN_COMPARISON = 'bypass_gwg_plan_comparison_page_and_go_to_checkout';
export const ENABLE_VALUE_PLAN = 'enableValuePlan';
